import { assign } from 'lodash';

/** Shallow merge for socket livescore patches — avoids cloneDeep on large aggregates. */
export const shallowMergeEventDetails = (eventDetails, patch) => {
  if (!eventDetails) return { ...patch };
  return assign({}, eventDetails, patch);
};

export default shallowMergeEventDetails;
